// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3Y-hZ","tab":"Tabs_tab__2Tw87","tabActive":"Tabs_tabActive__NWKIm"};